import { registerPageTab, registerCustomDetailComponent } from '@vendure/admin-ui/core';
import { SendPromoNotificationComponent } from './send-promo-notification/send-promo-notification.component';

export default [
    registerCustomDetailComponent({
        locationId: 'promotion-detail',
        component: SendPromoNotificationComponent,
    }),
    registerPageTab({
        location: 'promotion-detail',
        tab: 'Send Promo Notification',
        route: 'send-promo-notification',
        component: SendPromoNotificationComponent,
    }),
];
